<template>
  <div>
    <div class="mains" v-if="loading" v-loading="loading" element-loading-spinner="el-icon-loading"></div>
    <div v-else>
      <div class="man-title">
        <span>外勤计划</span>
        <el-button @click="add" class="btn" type="primary" size="mini" :disabled="roleId == 4">新增规则</el-button>
      </div>
      <div class="table-list">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="fieldPlanCode" label="任务ID"></el-table-column>
          <el-table-column prop="fieldPlanName" label="规则名称"></el-table-column>
          <el-table-column prop="fieldPlanDescribe" label="规则描述"></el-table-column>
          <el-table-column prop="staffName" label="外勤人员">
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.staffNames" :key="index">
                {{ scope.row.staffNames.length-1 > index ? item+'、' : item }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="startDate" label="日期段" width="200px">
            <template slot-scope="scope">
              {{ scope.row.startDate ? dayjs(scope.row.startDate).format('YYYY-MM-DD'):'-' }} 至 
              {{ scope.row.endDate ? dayjs(scope.row.endDate).format('YYYY-MM-DD'):'-' }}
            </template>
          </el-table-column>
          <el-table-column prop="cycleType" label="周期类型" width="100px">
            <template slot-scope="scope">
              <el-tag effect="dark" size="small" type="primary" v-show="scope.row.cycleType==0">月</el-tag>
              <el-tag effect="dark" size="small" type="primary" v-show="scope.row.cycleType==1">季</el-tag>
              <el-tag effect="dark" size="small" type="primary" v-show="scope.row.cycleType==2">年</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="repeat" label="是否重复" width="100px">
            <template slot-scope="scope">
              <el-tag size="small" type="success" v-show="scope.row.repeat==0">是</el-tag>
              <el-tag size="small" type="danger" v-show="scope.row.repeat==1">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="creator" label="创建人"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="200px">
            <template slot-scope="scope">
              {{ scope.row.createTime ? dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss'):'' }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == 0" size="small" type="warning">未开始</el-tag>
              <el-tag v-else-if="scope.row.status == 1" size="small" type="primary">进行中</el-tag>
              <el-tag v-else size="small" type="success">结束</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-dropdown v-if="staffId == scope.row.creatorId" placement="bottom-start" trigger="click">
                <span @click.stop="">
                  <span class="el-dropdown-link">
                    操作<i class="el-icon-arrow-down"></i>
                  </span>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item><div @click="details(scope.row)">详情</div></el-dropdown-item>
                  <el-dropdown-item :disabled="roleId == 4"><div @click="edit(scope.row)">编辑</div></el-dropdown-item>
                  <el-dropdown-item :disabled="roleId == 4"><div @click="dlt(scope.row)">删除</div></el-dropdown-item>
                  <el-dropdown-item :disabled="roleId == 4"><div @click="onOff(scope.row)">{{ scope.row.status == 0 ? '禁用':'启用' }}  </div></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown v-else placement="bottom-start" trigger="click">
                <span @click.stop="">
                  <span class="el-dropdown-dis">
                    操作<i class="el-icon-arrow-down"></i>
                  </span>
                </span>
                <el-dropdown-menu slot="dropdown"></el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column> -->
        </el-table>
        <page v-if="total!==0" :size="size" :page="page" :total="total" v-on:sizeChange="sizeChange" v-on:pageChange="pageChange"></page>
      </div>
    </div>
  </div>
</template>

<script>
import page from '@/components/page.vue'
import dayjs from 'dayjs';
export default {
  components: {
    page
  },
  data() {
    return {
      loading: false,
      size: 50,
      page: 1,
      total: 0,
      formInline: {},
      tableData: [],
      sheshi: [],
      staffId: 0,
      roleId: 0,
    }
  },
  methods: {
    dayjs,
    onOff(row) {
      this.$ajax.post("ruleStatus", {
        id: row.id,
        status: row.status == 0 ? 1 : 0
      }).then((res) => {
        this.loadTableData();
      });
    },
    onSubmit() {
      this.loadTableData()
    },
    details(row) {
      this.$router.push({ name: 'routineTaskDetail', params: {row: row}})
    },
    edit(row) {
      this.$router.push({ name: 'routineTaskEdit', params: {row: row}})
    },
    dlt(row) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$ajax.post("routineDelete",{}, {
          routineTaskCode: row.routineTaskCode,
        }).then((res) => {
          this.loadTableData();
        });
      });
    },
    add() {
      this.$router.push('/routineTask/add')
    },
    pageChange(val) {
      this.page = val
      sessionStorage.setItem('currentPage', val)
      this.loadTableData()
    },
    sizeChange(val) {
      this.size = val
      sessionStorage.setItem('currentSize', val)
      this.loadTableData()
    },
    getLastPage() {
      this.page = Number(sessionStorage.getItem('currentPage')) || 1
    },
    getSize() {
      this.size = Number(sessionStorage.getItem('currentSize')) || 50
    },
    loadTableData() {
      this.loading = true
      this.$ajax.post('routineQuery', {
        pageNum: this.page,
        pageSize: this.size,
      }).then(res => {
        this.loading = false
        this.tableData = res.data
        this.total = res.total
      }).catch(err=>{
        this.loading = false
      })
    },
  },
  mounted() {
    this.getLastPage()
    this.getSize()
    this.loadTableData()
    this.staffId = sessionStorage.getItem('id')
    this.roleId = sessionStorage.getItem('r')
  },
  destroyed() {
    // sessionStorage.removeItem('currentPage')
    // sessionStorage.removeItem('currentSize')
  }
}
</script>

<style lang="less" scoped>
.el-dropdown-dis {
  color: #ccc;
  cursor: not-allowed;
}
.mains {
  padding: 400px 0;
  height: 100%;
}
/deep/.el-loading-spinner .el-icon-loading{
  font-size: 50px;
}
.btn {
  float: right;
}
.search {
  padding: 0 10px;
}
</style>